// Dialóg „Chcete pokračovať?“ pri dokumente v inom ako slovenskom jazyku (23. 9. 2026).
// useLanguageConfirm() vráti { dialog, ask }; ask(items) → Promise<boolean>.
// Súbežné otázky (viac súborov zo servera naraz) sa zaradia za sebou.
import React, { useCallback, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box } from '@mui/material';
import { languageText } from './precheck';

export const useLanguageConfirm = () => {
  const [state, setState] = useState(null);   // { items, resolve }
  const queue = useRef(Promise.resolve());

  const ask = useCallback((items) => {
    const next = queue.current.then(() => new Promise((resolve) => setState({ items, resolve })));
    queue.current = next.catch(() => {});
    return next;
  }, []);

  const close = (value) => {
    if (state) state.resolve(value);
    setState(null);
  };

  const items = state?.items || [];
  const one = items.length === 1;
  const dialog = (
    <Dialog open={!!state} onClose={() => close(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{one ? 'Dokument v inom jazyku' : 'Dokumenty v inom jazyku'}</DialogTitle>
      <DialogContent>
        {one ? (
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            Dokument „{items[0].file.name}“: {languageText(items[0].lang)}.
          </Typography>
        ) : (
          <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 1.5 }}>
            {items.map(({ file, lang }) => (
              <li key={file.name + file.size}><Typography variant="body2">„{file.name}“: {languageText(lang)}</Typography></li>
            ))}
          </Box>
        )}
        <Typography variant="body2" color="text.secondary">
          Anonymizácia je určená pre dokumenty v slovenskom jazyku. Pri inom jazyku nemusí nájsť všetky osobné údaje.
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, fontWeight: 600 }}>Chcete pokračovať?</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => close(false)}>{one ? 'Zrušiť' : 'Vynechať tieto súbory'}</Button>
        <Button variant="contained" onClick={() => close(true)}>{one ? 'Pokračovať' : 'Pokračovať so všetkými'}</Button>
      </DialogActions>
    </Dialog>
  );
  return { dialog, ask };
};

export default useLanguageConfirm;
